module.exports = __webpack_public_path__ + "img/file-upload-logo.14abfd17.svg";